module.exports = __webpack_public_path__ + "media/images/athletes/3418-97366a4301b4ce0e75be90bab7c3fbdf.png";